import { render, staticRenderFns } from "./Personage.vue?vue&type=template&id=57bf8440&scoped=true"
import script from "./Personage.vue?vue&type=script&lang=js"
export * from "./Personage.vue?vue&type=script&lang=js"
import style0 from "./Personage.vue?vue&type=style&index=0&id=57bf8440&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bf8440",
  null
  
)

export default component.exports